// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3NUtK","header":"PatientBlock_header__2i2Kn","label":"PatientBlock_label__1Xzmd","option":"PatientBlock_option__1qAe4"};